module.exports = __webpack_public_path__ + "img/intercom_chat_icon.f25c76cb.svg";